export default __webpack_public_path__ + "static/media/INDEXX-500.950c9e88.gif";